
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28.73 28.73"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.93 2.97a11.52 11.52 0 00-8.86 6.29 22.39 22.39 0 018.86-2zm2.88 4.25a22.39 22.39 0 018.86 2 11.52 11.52 0 00-8.86-6.29zM2.88 14.37c0 1.76 4.49 4.32 11.49 4.32s11.49-2.55 11.49-4.31-3.87-4-10-4.27v2.67a2.12 2.12 0 01.71 1.6 2.15 2.15 0 11-4.3 0 2.12 2.12 0 01.71-1.6V10.1c-6.18.31-10 2.64-10 4.27zm1.19 5.11a11.5 11.5 0 0020.6 0 23.57 23.57 0 01-10.3 2.07 23.57 23.57 0 01-10.3-2.07zm10.3 9.26A14.37 14.37 0 0112.93.08V0l2.88.08a14.37 14.37 0 01-1.44 28.66z","fill-rule":"evenodd"}})])
          )
        }
      }
    